<div class="device-overview-widget-container d-flex flex-column h-100">
  <!-- Header -->
  <div class="row">
    <div class="col-12 dashboard-panel-header-flex-container">
      <span class="h6 lightgray-font">{{ title | translate}}</span>
      <div>
        <button class="btn btn-light dashboard-panel-button" (click)="onForceRefresh()" title="{{'i18n.domain.home.dashboard.shared.refresh-widget-data' | translate}}">
          <span class="icon-reset"></span>
        </button>
        @if (mode === WidgetMode.Edit || mode === WidgetMode.Preview) {
          <button class="btn btn-light dashboard-panel-button" (click)="onConfigure()">
            <span class="icon-settings"></span>
          </button>
        }
        @if (mode === WidgetMode.Edit) {
          <button class="btn btn-light dashboard-panel-button" (click)="onDelete()">
            <span class="icon-trash-can" style="color:red"></span>
          </button>
        }
      </div>
    </div>
  </div>
  <!-- Content -->

  <div class="row flex-grow-1">
    <div class="col-12 h-100">
      <div class="map-container h-100" #mapContainer>
        @if (selectedClientDto !== null) {
          @if (devices == null || devices.length === 0) {
            @if (dataLoaded) {
              <div class="text-center">
                <div appMessageDirective
                    [variant]="MessageVariant.Standart"
                    [severity]="MessageSeverity.AVPColors">
                  {{'i18n.domain.home.dashboard.device-overview-widget.no-device-found' | translate}}
                </div>
              </div>
            }
          } @else {
            <app-map-box-map [(mapData)]="mapData" [mapHeight]="mapHeight" [isReadOnly]="true"></app-map-box-map>
          }
        } @else {
          <div class="text-center">
            <div appMessageDirective
                [variant]="MessageVariant.Standart"
                [severity]="MessageSeverity.AVPColors">
              {{'i18n.domain.home.dashboard.device-interaction-widget.no-client-selected' | translate}}
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<ejs-dialog #widgetSettingsDialog
            class="dialog-min-height"
            [isModal]="true"
            [showCloseIcon]="true"
            (close)="onCloseSettingsDialog()"
            [visible]="false">
  <ng-template #header>
    {{'i18n.domain.home.dashboard.edit-settings-dialog-title' | translate}}
  </ng-template>
  <ng-template #content>
    @if (widgetSettingsDialog.visible) {
      <form id="deviceOverviewWidgetSettingsForm" [formGroup]="editSettingsForm" autocomplete="off">
        <div class="row">
          <div class="form-group col-12">
            <label class="control-label">{{'i18n.domain.home.dashboard.shared.widgets.title' | translate}}</label>
            <input id="title" name="title" type="text" autocomplete="off" class="form-control" formControlName="title" />
          </div>
        </div>
        <div class="row" >
          @if (hasUserClientAssigned) {
            <div class="form-group col-12">
              <label class="control-label">{{'i18n.base.shared.client-dropdown.client' | translate}}</label>
              <br />
              <span>{{selectedClientDto?.name}}</span>
            </div>
          } @else {
            <div class="col-12">
              <label class="control-label required">{{'i18n.base.shared.client-dropdown.client' | translate}}</label>
              <app-client-autocomplete client-autocomplete [(selectedClient)]="selectedClientDto" class="client-autocomplete me-2"></app-client-autocomplete>
            </div>
          }
        </div>
      </form>
    }
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-primary" (click)="saveParameters()">
      {{'i18n.shared.ok' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
